import React, { useState } from 'react';
import { Popover, Button, Tag } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

const STORAGE_KEY = 'journey_readonly_notice_dismissed';

export default function ReadOnlyNotice() {
  const [visible, setVisible] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) !== '1'; } catch { return true; }
  });
  const close = () => {
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch {}
    setVisible(false);
  };
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', marginLeft: 8 }}>
      <Tag color="orange" style={{ marginRight: 0 }}>Early Access - Read Only Mode</Tag>
      <Popover
        visible={visible}
        onVisibleChange={(v) => (v ? setVisible(true) : close())}
        placement="bottomLeft"
        trigger="click"
        title="Early Access - Read Only Mode"
        overlayStyle={{ maxWidth: 360 }}
        content={
          <div style={{ padding: '12px 16px' }}>
            <p style={{ margin: 0, marginBottom: 16, lineHeight: 1.5 }}>
              Journeys is in early access and read-only right now.
              Editing controls are visible but no changes are saved.
              Updates coming soon.
            </p>
            <div style={{ textAlign: 'right' }}>
              <Button onClick={close}>Dismiss</Button>
            </div>
          </div>
        }
      >
        <Button type="text" icon={<InfoCircleOutlined />} aria-label="About this preview" />
      </Popover>
    </span>
  );
}
